/**
 * Hero section -- Swiper init (csak akkor, ha 2+ slide van).
 *
 * DOMContentLoaded-be csomagolva: a deferelt scriptek dokumentum-sorrendben
 * futnak, és a main.min.js MEGELŐZHETI a swiper-bundle-t -- azonnali futásnál
 * a Swiper még undefined lenne, és a carousel csendben nem indulna el.
 */
(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    var heroes = document.querySelectorAll('.hero .hero__swiper');
    if (!heroes.length || typeof Swiper === 'undefined') return;

    heroes.forEach(function (el) {
      var sectionEl = el.closest('.hero');
      var autoplay  = sectionEl && sectionEl.getAttribute('data-autoplay') === '1';
      var delay     = sectionEl ? (parseInt(sectionEl.getAttribute('data-delay'), 10) || 5000) : 5000;

      new Swiper(el, {
        loop: true,
        speed: 700,
        effect: 'slide',
        autoplay: autoplay ? { delay: delay, disableOnInteraction: false, pauseOnMouseEnter: true } : false,
        pagination: {
          el: sectionEl ? sectionEl.querySelector('.hero__pagination') : null,
          clickable: true,
        },
        navigation: {
          prevEl: sectionEl ? sectionEl.querySelector('.hero__nav--prev') : null,
          nextEl: sectionEl ? sectionEl.querySelector('.hero__nav--next') : null,
        },
      });
    });
  });
})();
